/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import type { ComponentAttrs } from 'flarum/common/Component';
import FlarumSeparator from 'flarum/common/components/Separator';

/**
 * Any attribute passed to this component is merged onto the separator's root
 * element (e.g. `data-label`).
 */
export interface SeparatorAttrs extends ComponentAttrs {}

export default class Separator extends FlarumSeparator {
	view(): JSX.Element {
		const vdom = super.view();
		vdom.attrs = { ...vdom.attrs, ...(this.attrs as SeparatorAttrs) };
		return vdom;
	}
}
